require('./bootstrap');

// require('../../../public/html/dist/bundle.js');
require('./origin');


var Inputmask = require('inputmask');

$(function () {
    $(document).ready(function(){
        $('.order-method-popover').popover({
            html : true,
            placement: 'left',
            content: function() {
                var content = $(this).attr("data-popover-content");
                return $(content).children(".popover-body").html();
            },
        });



        Inputmask({
            regex: "[0-9,A-z, ]*"
        }).mask('.input-eng-letters-only');
    });


    // Item active
    let menuItems = $(".nav-link");
    $.each(menuItems, function (key, value) {
        if (value.href === document.URL) {
            $(this).addClass("active");
        }
    });

    setTimeout(function () {
        $('.badge').off();
    }, 1000);

    $('body')
        .on('mouseenter touchstart', 'header .catalog-menu', function () {
            $('#menu-overlay').show();
        })
        .on('mouseleave', 'header .catalog-menu', function () {
            $('#menu-overlay').hide();
        });
});

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

window.Noty = require('noty');
Noty.overrideDefaults({
    layout: 'topRight',
    theme: 'nest',
    timeout: 2000
});

require('./utils/deleteWithForm');
require('./utils/forms');
require('./modules/account');
require('./modules/register');
require('./modules/delivery');
require('./modules/subscribe');
require('./modules/filter');
require('./modules/compare');
require('./modules/favorite');
require('./modules/cart');
require('./modules/checkout');
require('./modules/catalog');
require('./modules/pagination');
require('./modules/items-view');
require('./modules/map');
require('./modules/search');

$('body').on('submit-success', '#callbackModal', function () {
    $(this).modal('hide');
    $('#callbackModalSuccess').modal('show');
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js